<template>
  <section class="notifications card navbar-notifications">
    <header class="cardHeader card-header">
      <div class="text-center mb-sm">
        <strong>You have {{unread}} new notifications</strong>
      </div> 
      <!-- <b-button-group id="notification-b-buttons">
        <b-button variant="default" @click="changeNotificationsTab(1)">Notifications</b-button>
        <b-button variant="default" @click="changeNotificationsTab(2)">Messages</b-button>
        <b-button variant="default" @click="changeNotificationsTab(3)">Progress</b-button>
      </b-button-group> -->
    </header>
    <NewNotificationsList :notifications="newNotifications"/>
    <!-- <NotifictionsList v-else-if="notificationsTabSelected === 1" />
    <Messages v-else-if="notificationsTabSelected === 2" />
    <Progress v-else-if="notificationsTabSelected === 3" />
    <NotifictionsList v-else/> -->
    <footer class="cardFooter text-sm card-footer position-relative">
      <span class="fs-mini">Synced at: {{last_check_at}}</span>
      <b-button
        variant="link"
        @click="loadNotifications"
        :class="{disabled: isLoad, 'btnNotificationsReload btn-xs float-right py-0': true}"
      >
        <span v-if="isLoad"><i class="la la-refresh la-spin" /> Loading...</span>
        <i v-else class="la la-refresh" />
      </b-button>
    </footer>
  </section>
</template>

<script>
import Vue from 'vue';

import NewNotificationsList from './NotificationsDemo/NewNotificationsList';
import moment from 'moment';
import common from '@/assets/js/common.js';

export default {
  name: 'Notification',
  mixins: [common],
  components: {
    NewNotificationsList
  },
  data() {
    return {
      notificationsTabSelected: 1,
      newNotifications: [],
      unread: 0,
      last_check_at: moment().format('YYYY-MM-DD HH:MM'),
      isLoad: false,
    }
  },
  mounted(){
    this.loadNotifications();

    setTimeout(() => {
      this.loadNotifications();
    }, 1500);
  },
  methods: {
  //   changeNotificationsTab(tab) {
  //     Vue.set(this, 'newNotifications', []);
  //   },
    loadNotifications() {
      this.isLoad = true;
      this.getNotifications();
    },
    getNotifications: function(){
      let uri = 'notifications';
      this.call_axios(uri).then(({response}) => {
        this.newNotifications = response.data;
        this.isLoad = false;
        this.last_check_at = moment().format('YYYY-MM-DD HH:MM');

        this.unread = this.newNotifications.filter(item => !item.read_at).length
      });      
    }
  }
};
</script>

<style src="./Notifications.scss" lang="scss" />
